export default __webpack_public_path__ + "static/media/news3.83bd7b91.png";